import CTNTable from '@ctn/ui/components/ctn-table';
import classNames from 'classnames';
import { parse } from 'date-fns';
import { useMemo } from 'react';

import { FORMAT_DATE } from '@/constants/date.constants';
import { PAGE_SIZE } from '@/constants/table.constants';
import { type Evento } from '@/interfaces/model/eventos.interface';

import { getColumns } from './columns';

type EventoListadoProps = {
	readonly data: Evento[];
	readonly className?: string;
	readonly disabledColumn?: { detalle?: boolean };
};

const EventoListado = ({ data, className, disabledColumn }: EventoListadoProps) => {
	const sortedAscData = useMemo(
		() =>
			data.toSorted((a, b) => {
				const dateA = parse(a.fechaCreacion, FORMAT_DATE.WITH_HOUR, new Date());
				const dateB = parse(b.fechaCreacion, FORMAT_DATE.WITH_HOUR, new Date());
				return dateB.getTime() - dateA.getTime();
			}),
		[data],
	);

	return (
		<CTNTable
			idData="fechaCreacion"
			loading={false}
			loadingConf={{ spinner: true }}
			className={classNames('c-pnp-table', className)}
			columns={getColumns({ disabled: disabledColumn })}
			data={sortedAscData}
			totalData={data.length}
			noDataConf={{ description: 'Aún no se ha añadido ningún movimiento' }}
			pageSize={PAGE_SIZE.HISTORIAL}
		/>
	);
};

export default EventoListado;
